import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addTransaction({ commit, rootGetters: { getUser, getOrder } }) {
    try {
      const { data } = await request.post(`/orders/${getOrder.id}/transactions`, {
        amount: getOrder.sum_total,
        user_id: getUser.id,
      });

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('updateTransaction', { transaction: data.transaction });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
